<template>
  <CContainer>
    <h4 class="mt-3">Documentos Anexos</h4>
    <CCard class="mt-3">
      <!-- <CCardHeader>
        <CCardTitle>
          Documento Anexo
        </CCardTitle>
        <CCardSubtitle>
          <small>
            Descripcion de la pantalla
          </small>
        </CCardSubtitle>
      </CCardHeader> -->
      <CCardBody>
        <VerticalDynamicForm :fields="attachments_fields" />
      </CCardBody>
      <CCardFooter>
        <div class="d-flex justify-content-center">
          <CButton
            color="success"
            :class="isValidForm ? '' : 'disabled'"
            :disabled="!isValidForm"
            @click="(event) => {
              event.stopPropagation()
              saveAttachment()
            }">
            <CIcon name="cil-check-circle"></CIcon>
            <span class="align-middle ml-2">Grabar</span>
            <CSpinner 
              size="sm" 
              class="align-middle mx-2" 
              v-show="loading" />
          </CButton>
          <CButton 
            color="danger"
            variant="outline"
            class="ml-2"
            @click="(event) => {
              event.stopPropagation()
              close()
            }">
            <CIcon name="cil-x-circle"></CIcon>
            <span class="align-middle ml-2">Cancelar</span>
          </CButton>
        </div>
      </CCardFooter>
    </CCard>
  </CContainer>
</template>

<script>
  import { toBase64 } from "@/general";
  import { dataListTiposAnexos } from "@/apiDataList";
  import { grabaDocumentoAnexo } from "@/api";

  import VerticalDynamicForm from "../containers/VerticalDynamicForm.vue";

  export default {
    name: "FormAttachments",
    components: {
      VerticalDynamicForm,
    },
    setup() {
    },
    props: {
      idDirectory: String,
      idEmployee: String,
      idDocument: String,
      idOrder: String,
      idLeasingContract: String
    },
    data() {
      return {
        loading: false,
        attachments_fields: [
          {
            type: "select",
            key: "idTipoAnexo",
            label: "Tipo Anexo:",
            value: "",
            options: [],
            required: true,
            prepend_content: {
              name: "bookmark"
            }
          },
          {
            type: "textarea",
            key: "observaciones",
            label: "Observaciones:",
            value: ""
          },
          {
            type: "file",
            key: "archivo",
            label: "Archivo:",
            value: "",
            required: true
          }
        ]
      }
    },
    methods: {
      toBase64,
      async getTiposAnexos() {
        const response = await dataListTiposAnexos(this)

        this.attachments_fields[0].options = [
          {
            label: "Seleccionar",
            value: ""
          },
          ...response.map(item => {
            return {
              label: item.descripcion,
              value: item.id_TipoAnexo
            }
          })
        ]
      },
      async saveAttachment() {
        this.loading = true

        try {
          let fileName = this.attachments_fields[2].value[0].name
          let fileBase64 = await this.toBase64(this.attachments_fields[2].value).then(file => file)
          let parametros = {
            "Id_TipoAnexo": this.attachments_fields[0].value,
            "Id_Directorio": this.idDirectory ? this.idDirectory : null,
            "Id_Personal": this.idEmployee ? this.idEmployee : null,
            "Id_Documento": this.idDocument ? this.idDocument : null,
            "Id_Pedido": this.idOrder ? this.idOrder : null,
            "Id_ContratoArrendamiento": this.idLeasingContract ? this.idLeasingContract : null,
            "Observaciones": this.attachments_fields[1].value ? this.attachments_fields[1].value : null,
            "Nombre_Archivo": fileName,
            "Archivo_Base64": fileBase64
          }
  
          const { errorCode, errorMessage, response} = await grabaDocumentoAnexo(this, parametros)
  
          if (errorCode === 0) {
            this.$store.commit("setAlert", {
              color: "success",
              message: `Se grabo el archivo ${response.nombre_Documento} exitosamente...`,
              show: 5
            })
          } else {
            this.$store.commit("setAlert", {
              color: "warning",
              message: errorMessage,
              show: 5
            })
          }
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error ${error.status} - ${error.statusText}`,
            show: 5
          })
        } finally {
          this.loading = false
          this.close()
        }
      },
      close() {
        this.$emit("closeWindow")
      }
    },
    mounted() {
      this.getTiposAnexos()
    },
    computed: {
      isValidForm() {
        return this.attachments_fields.every(field => {
          if (field.required) {
            if (typeof field.value === "string") {
              return field.value.length > 0
            }
            if (typeof field.value === 'object') {
              return field.value.length > 0
            }
          }

          return true
        })
      }
    }
  }
</script>
